import { CONST_ROWS_PER_PAGE } from '@commons/consts';
import {
    NEW_TRANSPORTADORA_CADASTRO_SUCCESS,
    CANCEL_TRANSPORTADORA_CADASTRO_RAPIDO,
    CANCEL_TRANSPORTADORA_CADASTRO_RAPIDO_SUCCESS,
    TABLE_TRANSPORTADORA_CADASTRO_PENDING,
    TABLE_TRANSPORTADORA_CADASTRO_SUCCESS,
    TABLE_TRANSPORTADORA_CADASTRO_FAILURE,
    LIST_TRANSPORTADORA_CADASTRO_PENDING,
    LIST_TRANSPORTADORA_CADASTRO_SUCCESS,
    LIST_TRANSPORTADORA_CADASTRO_FAILURE,
    FIND_TRANSPORTADORA_CADASTRO_PENDING,
    FIND_TRANSPORTADORA_CADASTRO_SUCCESS,
    FIND_TRANSPORTADORA_CADASTRO_FAILURE,
    DELETE_TRANSPORTADORA_CADASTRO_PENDING,
    DELETE_TRANSPORTADORA_CADASTRO_SUCCESS,
    DELETE_TRANSPORTADORA_CADASTRO_FAILURE,
    CREATE_TRANSPORTADORA_CADASTRO_PENDING,
    CREATE_TRANSPORTADORA_CADASTRO_SUCCESS,
    CREATE_TRANSPORTADORA_CADASTRO_FAILURE,
    NEW_FILTER_TRANSPORTADORA_CADASTRO_PENDING,
    NEW_FILTER_TRANSPORTADORA_CADASTRO_SUCCESS,
    NEW_FILTER_TRANSPORTADORA_CADASTRO_FAILURE,
    NEW_FILTER_NEXT_PAGE_TRANSPORTADORA_CADASTRO_PENDING,
    NEW_FILTER_NEXT_PAGE_TRANSPORTADORA_CADASTRO_SUCCESS,
    NEW_FILTER_NEXT_PAGE_TRANSPORTADORA_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = {
  list: null,
  loading: false,
  filter: {
    rows: CONST_ROWS_PER_PAGE,
    page: 0,
    where: '',
  },
};


function transportadoraCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_TRANSPORTADORA_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_TRANSPORTADORA_CADASTRO_PENDING:
        case FIND_TRANSPORTADORA_CADASTRO_PENDING:
        case DELETE_TRANSPORTADORA_CADASTRO_PENDING:
        case CREATE_TRANSPORTADORA_CADASTRO_PENDING:
        case TABLE_TRANSPORTADORA_CADASTRO_PENDING:
        case NEW_FILTER_TRANSPORTADORA_CADASTRO_PENDING:
        case NEW_FILTER_NEXT_PAGE_TRANSPORTADORA_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_TRANSPORTADORA_CADASTRO_RAPIDO:
        case CANCEL_TRANSPORTADORA_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_TRANSPORTADORA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_TRANSPORTADORA_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_TRANSPORTADORA_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_TRANSPORTADORA_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_TRANSPORTADORA_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_TRANSPORTADORA_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_TRANSPORTADORA_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_TRANSPORTADORA_CADASTRO_SUCCESS: {
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        }
        case NEW_FILTER_TRANSPORTADORA_CADASTRO_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_NEXT_PAGE_TRANSPORTADORA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_TRANSPORTADORA_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_TRANSPORTADORA_CADASTRO_SUCCESS:
        case CREATE_TRANSPORTADORA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_TRANSPORTADORA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { transportadoraCadastroReducer };